import React from "react";
import "./display-expression-scroll-arrow.component.scss";

export interface IDisplayExpressionScrollArrowProperties {
  direction: "left" | "right";
  onClick: () => void;
}

export const DisplayExpressionScrollArrowComponent: React.FC<IDisplayExpressionScrollArrowProperties> = ({
  direction,
  onClick,
}) => (
  <button
    onClick={() => onClick()}
    className={`display-expression-scroll-arrow display-expression-scroll-arrow-${direction}`}
  >
    {direction === "left" ? "<" : ">"}
  </button>
);
